module.exports = __webpack_public_path__ + "4567444f8c35aa8e0a536f78073e4315.svg";